export { default } from './AuthenticatedRoutes';
